import axios from 'axios';

// En production (build), le frontend et l'API sont sur le même domaine :
// Apache redirige /api vers le backend Node (port 5000).
// En développement (npm start), on garde http://localhost:5000.
const IS_PROD = process.env.NODE_ENV === 'production';

// Racine du serveur pour les images : '/api' en prod, 'http://localhost:5000' en dev
// Utilisation : SERVER_URL + '/uploads/produits/' + fichier
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || (IS_PROD ? '/api' : 'http://localhost:5000');

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || (IS_PROD ? '/api' : 'http://localhost:5000/api')
});

// Avant chaque requête, on ajoute automatiquement le token
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

// Si le token expire, on redirige vers la connexion
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('utilisateur');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default API;